import * as yup from 'yup';

import Base from './Base';

const shareReportEmailSchema = yup.object().shape({
  email: yup.string().email('Invalid email format').required('Email is required'),
  name: yup.string().required('Name is required'),
});

export default class ShareReportEmail extends Base {
  static validateCreate(item, fields) {
    return super.validate(item, fields, shareReportEmailSchema);
  }

  static validateUpdate(item, fields) {
    return super.validate(item, fields, shareReportEmailSchema);
  }

  name = '';
  email = '';

  constructor(props) {
    super();
    this.clone(props);
  }
}
